import { AllowedEvents, TrackEvent } from '@opallabs/quanta'
import { CardContextValue } from '../../../../../cardContext'
import { getContentDragData } from '../../../../dragData'

const getDropIndex = (
  droppedMomentId: string,
  thisMomentId: string,
  droppedIndex: number,
  thisIndex: number
): number => {
  if (droppedMomentId === thisMomentId && droppedIndex < thisIndex) {
    return thisIndex
  }
  return thisIndex + 1
}

export const updateContentFromDrop = ({
  contentIndex,
  dropEvent,
  moment,
  onMoveContent,
  onReorderContent,
  resetDragStates,
  track,
}: {
  contentIndex: number
  dropEvent: React.DragEvent
  moment: any
  onMoveContent?: CardContextValue['onMoveContent']
  onReorderContent?: CardContextValue['onReorderContent']
  resetDragStates: () => void
  track?: TrackEvent
}) => {
  const {
    contentId,
    contentPosition: originContentPosition,
    momentId: originMomentId,
  } = getContentDragData(dropEvent) ?? {}

  if (!contentId || !originMomentId || !originContentPosition) return

  const destinationMomentId = moment.id
  const droppedOnSameMoment = destinationMomentId === originMomentId

  if (typeof track === 'function') {
    track(AllowedEvents.drop, {
      id: contentId,
      dragIntent: droppedOnSameMoment ? 'reordered' : 'moved',
      type: 'content',
    })
  }

  resetDragStates()

  if (!droppedOnSameMoment) {
    onMoveContent?.({
      originMomentId,
      destinationMomentId,
      contentId,
      newContentPosition: getDropIndex(
        originMomentId,
        moment.id,
        originContentPosition,
        contentIndex
      ),
    })
  } else {
    onReorderContent?.({
      destinationIndex: getDropIndex(
        originMomentId,
        destinationMomentId,
        originContentPosition,
        contentIndex
      ),
      moment: moment,
      originIndex: originContentPosition,
    })
  }
}
